(function ($) {
  const privacyNavigationBehavior = () => {
    if (window.matchMedia("(min-width: 768px)").matches) {
      const privacyPolicy = $(".privacy-policy");
      if (privacyPolicy.length != 0) {
        let urlHash = window.location.hash;
        if (urlHash.length) {
          //Trigger click not working correct without delay time
          setTimeout(function () {
            $(".privacy-policy .bs-column--left-side-navigation .bs-pro-button a[href='" + urlHash + "']").trigger("click");
          }, 50);
        } else {
          //no hash value
          $(".privacy-policy .bs-column--left-side-navigation .bs-pro-button").first().addClass("title-active");
        }

        let allHeadings = document.querySelectorAll(".privacy-policy .bs-div---default h4");
        const windowHeight = $(window).innerHeight(); // get window height
        const headerHeight = $("#header").innerHeight() + 120; // header height + privacy banner height
        let rootHeight = windowHeight - (headerHeight + 100); // reduce height 4/1
        rootHeight = rootHeight < 0 ? 100 : rootHeight;

        let config = {
          root: null,
          rootMargin: `-${headerHeight}px 0px -${rootHeight}px 0px`,
          threshold: 0.1,
        };
        let privacyObserver = new IntersectionObserver(function (entries, self) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var targetIdReady = $(entry.target).parents(".bs-div").attr("id");
              if (typeof targetIdReady != "undefined") {
                $(".privacy-policy .bs-column--left-side-navigation .bs-pro-button").removeClass("title-active");
                $(`.privacy-policy .bs-column--left-side-navigation .bs-pro-button a[href="#${targetIdReady}"]`).parent().addClass("title-active");
              }
            }
          });
        }, config);
        allHeadings.forEach(function (element) {
          privacyObserver.observe(element);
        });

        const $btn = $(".bs-section--privacy-policy .bs-pro-button"),
          $menuWrapper = $(".privacy-policy .bs-column--left-side-navigation");
        let adminBarHeight = 0;

        $menuWrapper.find('a[href^="#"]').each((index, element) => {
          const $this = $(element);
          $this.on("click", (e) => {
            if ($("#wpadminbar").length) {
              adminBarHeight = parseInt($("#wpadminbar").outerHeight() - 20);
            }
            if ($($this.attr("href")).length) {
              const offsetPosition = $($this.attr("href")).offset().top - headerHeight;
              $("html, body").stop().animate(
                {
                  scrollTop: offsetPosition,
                },
                1000
              );
            }
          });
        });
      }
    }
  };

  $(window).on("load resize", () => {
    privacyNavigationBehavior();
  });
})(jQuery);
